const selectors = {
  createAdsResult: (state) => state.wizard.createAdsResult,
};

export default selectors;
